export default __webpack_public_path__ + "static/media/section2-7-num4.807a632f.png";